import { Select } from "antd";
import React from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
const AddApplicant = ({
  role,
  handleChange,
  createAdmin,
  loading,
  options,
  assignedSchool,
  userData,
}) => {
  return (
    <Form className="mt-3" onSubmit={createAdmin}>
      <Row>
        <Col lg="6">
          <FormGroup className="mb-3">
            <Label for="firstname">First Name</Label>
            <Input
              id="firstname"
              name="firstName"
              value={userData.firstName}
              onChange={handleChange}
              placeholder="First name"
              type="text"
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup className="mb-3">
            <Label for="lastName">Last Name</Label>
            <Input
              id="lastName"
              name="lastName"
              value={userData.lastName}
              onChange={handleChange}
              placeholder="Last name"
              type="text"
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup className="mb-3">
            <Label for="exampleEmail">Email</Label>
            <Input
              id="exampleEmail"
              name="email"
              value={userData.email}
              onChange={handleChange}
              placeholder="Email"
              type="email"
              autoComplete="new-email"
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup className="mb-3">
            <Label for="mobile">Mobile</Label>
            <Input
              id="mobile"
              name="mobile"
              value={userData.mobile}
              onChange={handleChange}
              placeholder="Mobile"
              type="tel"
            />
          </FormGroup>
        </Col>
        <Col lg="12">
          <FormGroup className="mb-3">
            <Label for="password">Password</Label>
            <Input
              id="password"
              name="password"
              value={userData.password}
              onChange={handleChange}
              placeholder="Password"
              type="password"
              autoComplete="new-password"
            />
          </FormGroup>
        </Col>
        {role === "vendor" ? (
          <Col lg="12">
            <FormGroup className="mb-4">
              <Label for="school_code">School Code</Label>
              <Select
                mode="multiple"
                allowClear
                style={{
                  width: "100%",
                  height: "calc(1.5em + 1.25rem + 2px)",
                }}
                value={userData.schoolsAdminId}
                placeholder="Please select"
                onChange={(items) => {
                  assignedSchool({ ...userData, schoolsAdminId: items });
                }}
                options={options}
              />
            </FormGroup>
          </Col>
        ) : (
          <>
            <Col lg="12">
              <FormGroup className="mb-3">
                <Label for="school_name">School Name</Label>
                <Input
                  id="school_name"
                  name="school_name"
                  value={userData.school_name}
                  onChange={handleChange}
                  placeholder="School name"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col lg="6">
              <FormGroup className="mb-3">
                <Label for="school_city">School City</Label>
                <Input
                  id="school_city"
                  name="school_city"
                  value={userData.school_city}
                  onChange={handleChange}
                  placeholder="City"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col lg="6">
              <FormGroup className="mb-4">
                <Label for="school_code">School Code</Label>
                <Input
                  id="school_code"
                  name="school_code"
                  value={userData.school_code}
                  onChange={handleChange}
                  placeholder="School code"
                  type="text"
                />
              </FormGroup>
            </Col>
          </>
        )}
        <Col lg="12">
          <FormGroup className="mb-3">
            <Button
              color="dark"
              type="submit"
              className="w-100"
              block
              disabled={loading}
            >
              {loading && <Spinner size="sm" className="mr-2" />} Submit
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
export default AddApplicant;
